import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import AppUploadIcon from "../../../media/app-images/AppUploadIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import AppCpeCveIcon from "../../../media/app-images/AppCpeCveIcon.mjs";
import {Button, ButtonGroup, Col, Container, Form, Label, Nav, NavItem, NavLink, Progress, Row, TabContent, TabPane} from "reactstrap";
import FolderUploader from "../../../controls/FolderUploader/FolderUploader.mjs";
import AppOkIcon from "../../../media/app-images/AppOkIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import "../../MultiLoader.css";
import CveLoadStatus from "../../../ComponentParts/CVE/CveLoadStatus.mjs";
import "./CveLoader.css";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import FileIcon from "../../../media/images/FileIcon.mjs";
import FolderOpenIcon from "../../../media/images/FolderOpenIcon.mjs";
import CveLoaderFilterModal from "./CveLoaderFilterModal.mjs";
import SvgPie from "../../../controls/MySVG/SvgPie.js";

const prefix = "CveLoader";

const CveLoader = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: Glob.getPageParam('tab'),
			lang: Glob.getLanguage(),
			ll: Glob.getLanguageLong(),
			files: [],
			totSize: 0,
			loadedFolders: [],
			loadedHistory: []
		};
		this.uid = Glob.generateUid(prefix);
		this.renderLoader = this.renderLoader.bind(this);
		this.renderForm  = this.renderForm.bind(this);
		this.parseFiles = this.parseFiles.bind(this);
		this.loader = this.loader.bind(this);
		this.startUploadProcess = this.startUploadProcess.bind(this);
		this.uploadNextFile = this.uploadNextFile.bind(this);
		this.chooseNvdFile = this.chooseNvdFile.bind(this);
		this.addNvdFile = this.addNvdFile.bind(this);
		this.processNvdFile = this.processNvdFile.bind(this);
		this.nvdFilter = this.nvdFilter.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle',['CVE','CveLoader']);
		Glob.setStatus('pageIcon',<AppCpeCveIcon /> );
		Glob.register('currentPage', cp => {
			const t = cp.params?.tab || "nvd";
			if ( t !== this.state.tab ) this.setState({ tab: t, files: [], totSize: 0, nvdInfo: null });
		}, this.uid);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if ( ll !== this.state.ll ) this.setState({ ll: ll, lang: Glob.getLanguage() });
		}, this.uid);
		if ( ! Glob.getPageParam('tab') ) Glob.setCurrentPageParam('tab','nvd');
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	parseFiles( files ) {
		if ( ! files || !files.length ) {
			this.setState({ files: [], loading: false, nvdInfo: null });
			return;
		}
		this.setState({ files: files.filter( x => !! x?.json?.cveMetadata ) });
	}
	startUploadProcess() {
		const loading = {
			numOfFiles: this.state.files.reduce( (tot,file)=>( tot + (file.massive||1)), 0),
			totalSize: this.state.files.reduce( (tot,x)=> tot + x.size, 0 ),
			doneSize: 0,
			index: 0,
			counter: 0,
			over: false,
			color: 'warning',
			count: {
				valid: {
					label: 'LoadedPF',
					value: 0,
					color: "#090"
				},
				skipped: {
					label: 'SkippedPF',
					value: 0,
					color: "#f90"
				},
				deleted: {
					label: 'RejectedPF',
					value: 0,
					color: "#90c"
				},
				errors: {
					label: 'Errors',
					value: 0,
					color: "#c00"
				}
			}
		};
		this.setState( {
			loading: loading,
			loadedFolders: [],
			ciphers: loading.numOfFiles.toString().length,
			uploadStartTime: Date.now()
		}, () => {
			appLib.api('cve/setup').then( this.loader )
		});
	}
	async loader() {
		if ( ! this.state.loading ) {
			this.startUploadProcess();
			return;
		}
		while ( ! this.state.loading?.over ) {
			await this.uploadNextFile();
		}
		this.parseFiles();
	}
	uploadNextFile() {
		const loading = this.state.loading;
		const file = this.state.files[loading?.index ?? 0];
		if ( ! file ) {
			return new Promise( resolve => {
				loading.over = true;
				loading.color = 'success';
				const hi = this.state.loadedHistory;
				if ( this.state.loadedFolders.length > 0 ) hi.push( this.state.loadedFolders );
				this.setState( {loading: loading, loadedHistory: hi, loadedFolders: []}, ()=>{
					setTimeout( resolve, 1000 );
				});
			});
		}
		return new Promise( resolve => {
			loading.index += 1;
			loading.counter += file.massive || 1;
			loading.color = 'primary';
			loading.doneSize += file.size;
			loading.currentName = file.name;
			if ( loading.counter > 100 ) {
				const spent = Date.now() - this.state.uploadStartTime;
				const rem = Math.round(( loading.totalSize - loading.doneSize ) * spent / ( 1000 * loading.doneSize )) ;
				const cveps = 1000 * loading.counter / spent;
				if ( ! loading.hiRes && rem < 1800 ) {
					const ratio = loading.doneSize / loading.totalSize;
					if ( ((loading.counter >= 1000 || rem < 60) && ratio > .25 ) || (ratio > .5 )) loading.hiRes = true;
				}
				if ( loading.hiRes ) {
					loading.etr = [
						<tt key={"min"}>{ String(Math.floor(rem/60)).padStart(2,'0') }</tt>,
						<tt key={"sec"}>{ String(rem % 60).padStart(2,'0') }</tt>
					];
				} else {
					loading.etr = <tt>{ Math.round(rem/60) || 1 }</tt>;
				}
				loading.avg = cveps > 2 ? Math.round(cveps) :  cveps.toFixed(2);
			}
			this.setState( {loading: loading}, ()=>{
				if ( ! file.json.dataType && Array.isArray( file.json.weaknesses ) && file.json.vulnStatus) {
					file.json.dataType = "NVD_CVE";
				}
				let uri = 'cve/load';
				if ( file.massive ) {
					uri = 'cve/load-nvd-massive';
				} else if ((file.json.dataType||'').toLowerCase().includes('nvd')) {
					uri = 'cve/load-nvd';
				}
				appLib.api(uri, file.json ).then( (res)=>{
					const ns = {};
					if ( res.massive ) {
						loading.count.deleted.value += res.deleted;
						loading.count.skipped.value += res.skipped;
						loading.count.valid.value += res.valid;
						loading.count.errors.value += res.errors;
					} else {
						if ( res?.deleted ) {
							loading.count.deleted.value++;
						} else if ( res.skip ) {
							loading.count.skipped.value++;
						} else if ( res?.error ) {
							loading.count.errors.value++;
						} else {
							loading.count.valid.value++;
						}
					}
					ns.loading = loading;
					const topFolder = file.filePath.split('/')[0];
					const lf = this.state.loadedFolders;
					if ( ! lf.includes(topFolder) ) {
						lf.push(topFolder);
						ns.loadedFolders = lf;
					}
					this.setState( ns, resolve );
				}).catch( e=>{
					console.error( `Error loading: ${file.name }`, e, file.json );
					loading.count.errors.value++;
					this.setState({ loading: loading}, resolve );
				})
			});
		});
	}
	chooseNvdFile() {
		this.setState({ nvdInfo: null, files: [], totalSize: 0 }, this.addNvdFile )
	}
	addNvdFile() {
		Glob.uploadJSON().then(
			this.processNvdFile
		).catch( err => {
			console.error( err );
		});
	}
	processNvdFile(all) {
		let filename;
		if ( all.name && all.json ) {
			filename = all.name.replace(/\.json$/i, '');
			all = all.json;
		}
		if ( all?.format !== 'NVD_CVE') {
			window.alert('Not a valid NVD CVE file.');
			return;
		}
		if ( ! Array.isArray( all.vulnerabilities ) ) {
			window.alert('No vulnerabilities found');
			return;
		}
		let pageSize = 2;
		const qtVunerabilities = all.vulnerabilities.length;
		if ( qtVunerabilities > 10000 ) {
			pageSize = 100;
		} else if ( qtVunerabilities > 5000 ) {
			pageSize = 50;
		} else if ( qtVunerabilities > 1000 ) {
			pageSize = 25;
		} else if ( qtVunerabilities > 100 ) {
			pageSize = 10;
		}
		this.setState( {parsingNvd: true}, ()=>{
			const files = this.state.files || [];
			let ts = this.state.nvdInfo?.totalSize || 0;
			const addBlock = b => {
				if ( ! (Array.isArray( b ) && b.length) ) return;
				files.push({
					massive: b.length,
					name: b[0].name,
					filePath: b[0].filePath,
					size: b.reduce( (s,cve)=>(s+cve.size),0),
					json: { cves: b.map( x => x.json ) }
				});
			}
			let block = [];
			for (const item of all.vulnerabilities ) {
				if ( block.length >= pageSize ) {
					addBlock(block);
					block = [];
				}
				const name = (item?.cve?.id || '').toLowerCase();
				if ( ! name ) continue;
				const cve = item.cve;
				const s = JSON.stringify(cve).length;
				ts += s;
				cve.dataType = all.format;
				block.push({
					filePath: `${filename || name.split('-')[1]}/${name}`,
					name: name,
					json: cve,
					size: s
				});
			}
			addBlock(block);
			this.setState({
				files: files,
				parsingNvd: false,
				nvdInfo: {
					version: all.version,
					count: files.reduce( (tot,file)=>( tot + (file.massive||1)), 0),
					totalSize: ts,
					date: new Date( (all.timestamp||'').replace(/T/, ' ') )
				}
			});
		});
	}
	nvdFilter( filter = false, apply = false ) {
		if ( ! filter ) return this.state.nvdInfo;
		const re = new RegExp(`^cve-${filter.year || "[0-9]{4}"}-${filter.num ? '0*'+filter.num : "[0-9]+"}$`);
		const newInfo = Glob.clone(this.state.nvdInfo);
		const newFiles = this.state.files.filter( x => !! x.name.match(re) );
		newInfo.count = newFiles.length;
		newInfo.totalSize = 0;
		newFiles.forEach( x => { newInfo.totalSize += x.size; } );
		if ( apply ) this.setState({ nvdInfo: newInfo, files: newFiles });
		return newInfo;
	}
	renderLoader() {
		const l = this.state.loading || {};
		const ww = window.innerWidth || window.document.documentElement.clientWidth;
		const pc = Math.round(1000 * (l.doneSize ?? 0)/(l.totalSize || 100))/10 + .01;
		return(
			<>
				<div className="loading">
					<div className={"upload-progress"}>
						<Container>
							{ ( l.over ) ? (
								<Row className={"top completed"}>
									<Col xs={12}>
										<span><TextLabel value={'Operation completed'} /></span>
									</Col>
								</Row>
							) : (
								<Row className={"top running"}>
									<Col xs={6} className={"main"}>
										<Label>
											<strong>{l.counter.toLocaleString(this.state.ll)}</strong>/{l.numOfFiles.toLocaleString(this.state.ll)}
										</Label>
										<div>
											{l.currentName ? <span>{ l.currentName}</span> : '—'}
										</div>
									</Col>
									{ ( !! l.avg ) ? (
										<Col xs={3} className={"avg"}>
											<Label>CVE/sec</Label>
											<div><tt>{ l.avg }</tt></div>
										</Col>
									) : <Col xs={3}/>}
									{ (!! l.etr ) ? (
										<Col xs={3} className={"etr"}>
											<Label>ETR</Label>
											<div>{ l.etr }</div>
										</Col>
									) : <Col xs={3} /> }
								</Row>
							) }
							<Row className={"middle"}>
								<Col xs={12}>
									<Progress
										animated
										striped
										color={ l.color }
										max={l.totalSize || 100}
										value={ l.doneSize ?? 0 }
									>
										{ pc > 9 && <tt>{pc.toLocaleString(this.state.ll).replace(/([^0-9][0-9]).+/, "$1")}</tt> }
									</Progress>
								</Col>
							</Row>
							<Row className={"bottom"}>
								<Col xs={3} style={{color:l.count.valid?.color}}>
									<Label>
										<TextLabel value={l.count.valid?.label ?? ''} />
									</Label>
									<div>
										<tt>{(l.count?.valid?.value||'').toString().padStart(this.state.ciphers,'·') }</tt>
									</div>
								</Col>
								<Col xs={3} style={{color:l.count.deleted?.color}}>
									<Label>
										<TextLabel value={l.count.deleted?.label ?? ''} />
									</Label>
									<div>
										<tt>{(l.count?.deleted?.value||'').toString().padStart(this.state.ciphers,'·') }</tt>
									</div>
								</Col>
								<Col xs={3} style={{color:l.count.skipped?.color}}>
									<Label>
										<TextLabel value={l.count.skipped?.label ?? ''} />
									</Label>
									<div>
										<tt>{(l.count?.skipped?.value||'').toString().padStart(this.state.ciphers,'·') }</tt>
									</div>
								</Col>
								<Col xs={3} style={{color:l.count.errors?.color}}>
									<Label>
										<TextLabel value={l.count.errors?.label ?? ''} />
									</Label>
									<div>
										<tt>{(l.count?.errors?.value||'').toString().padStart(this.state.ciphers,'·') }</tt>
									</div>
								</Col>
							</Row>
						</Container>
						<div>
							<SvgPie
								key={ l.index }
								size={ww > 1200 ? 240 : ( ww > 600? 160 : 80 ) }
								hole={ww > 1200 ? .66 :  ( ww > 600 ? .5 : .33 ) }
								border={1}
								borderColor={ l.count?.valid?.color }
								borderOffset={ ww > 1200 ? 2 : 1 }
								values={[
									l.count?.valid,
									l.count?.skipped,
									l.count?.deleted,
									l.count?.errors,
									{ value: (l.numOfFiles - l.counter), color: "#ffffff00" }
								]}
							/>
							<span>{(Math.round(1000 * (l.counter ?? 0)/(l.numOfFiles || 100))/10 + .01).toLocaleString(this.state.ll).replace(/([^0-9][0-9]).+/, "$1")}%</span>
						</div>
					</div>
					{ this.state.lang === 'it' ? (
						<div className={"legend"}>
							<h4>Legenda</h4>
							<ul>
								<li>
									La barra indica il progresso nel caricamento, si basa sulla dimensione dei dati
								</li>
								<li>
									La torta indica il progresso nei risultati di elaborazione, si basa sul numero di CVE
								</li>
							</ul>
						</div>
					) : (
						<div className={"legend"}>
							<h4>Key</h4>
							<ul>
								<li>
									Bar shows data loading progress, is based on data size
								</li>
								<li>
									Pie shows CVEs elaboration results progress, is based on the number of CVEs
								</li>
							</ul>
						</div>
					)}
				</div>
			</>
		);
	}
	renderForm() {
		return (
			<>
				<div className={"panel-content limited"}>
					<Nav tabs>
						<NavItem>
							<NavLink
								className={ this.state.tab === "nvd" ? "active" : "inactive"}
								onClick={ ()=>{ Glob.setCurrentPageParam('tab','nvd')}}
							>
								<FileIcon />
								<span lang={"en"}>CVE bundle</span>
								<span lang={"it"}>Archivio CVE</span>
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={ this.state.tab === "cve" ? "active" : "inactive"}
								onClick={ ()=>{ Glob.setCurrentPageParam('tab','cve')}}
							>
								<FolderOpenIcon />
								<span lang={"en"}>Folder of CVEs</span>
								<span lang={"it"}>Cartella di CVE</span>
							</NavLink>
						</NavItem>
					</Nav>
					<TabContent>
						{ this.state.tab === "nvd" && (
							<TabPane className={"active"}>
								{ ((this.state.files.length + this.state.loadedFolders.length + this.state.loadedHistory.length) === 0) && (
									<div className={"download-links"}>
										<div>
											<Label><strong>nvd.nist.gov</strong></Label>
										</div>
										<div>
											<a
												href={"https://nvd.nist.gov/vuln/data-feeds"}
												target="_blank"
												rel="noopener noreferrer"
												title={'🌐 '+Glob.label('Link to an external site')}
											>
												🌐 <TextLabel value={"Download page"} />
											</a>
											<a
												href={"https://nvd.nist.gov/feeds/json/cve/2.0/nvdcve-2.0-recent.json.zip"}
												target="_blank"
												rel="noopener noreferrer"
												title={'⚠️ '+Glob.label('Huge file size')}
											>
												⚠️ <TextLabel value={"Recent"} />
											</a>
										</div>
									</div>
								)}
								{ (this.state.loadedHistory.length > 0) && (
									<div className={"loadedHistory"}>
										{ this.state.loadedHistory.map( (h,idx) => (
											<div key={idx}>
												{h.map(f => (
													<div key={f}>
														<AppOkIcon /> <span>{ f }</span>
													</div>
												))}
											</div>
										))}
									</div>
								) }
								{ (! this.state.nvdInfo) ? (
									<Form
										className={"mt-2 mb-4"}
										onSubmit={ e => { e.preventDefault() }}
									>
										<div align={"center"}>
											<h6 lang={"it"}>
												Un file composto da CVE multiple da nvd.nist.gov
											</h6>
											<h6 lang={"en"}>
												A file with multiple CVEs from nvd.nist.gov
											</h6>
											<ButtonGroup className={"btn-icon"}>
												<Button
													disabled={ !! this.state.parsingNvd }
													color={"primary"}
													onClick={ this.chooseNvdFile }
												>
													<b>
														<TextLabel value={"Choose..."} /> <em>nvdcve-*.json</em>
													</b>
													<i>
														<FileIcon />
													</i>
												</Button>
											</ButtonGroup>
										</div>
									</Form>
								) : (
									<>
										<div className={"nvdInfo"}>
											<FileIcon />
											<ul>
												<li>
													<TextLabel value={"CVE"} />: <strong>{ this.state.nvdInfo.count.toLocaleString( this.state.ll) }</strong>
												</li>
												<li>
													NVD CVE <TextLabel value={"Version"} />: <strong>{ this.state.nvdInfo.version }</strong>
												</li>
												<li>
													<TextLabel value={"Date"} />: <strong>{ this.state.nvdInfo.date.toLocaleString(this.state.ll) }</strong>
												</li>
												<li>
													<TextLabel value={"Total size"} />: <strong>{ this.state.nvdInfo.totalSize.toLocaleString( this.state.ll) }</strong> B
												</li>
											</ul>
											<ButtonGroup>
												<Button onClick={ ()=>{ this.setState({showNvdFilterModal: true}) } } >
													<TextLabel value={"Filter"} />…
												</Button>
											</ButtonGroup>
										</div>
										<Form
											className={"mt-2 mb-2"}
											onSubmit={ e => { e.preventDefault() }}
										>
											<div align={"center"}>
												<ButtonGroup className={"btn-icon"}>
													<Button
														disabled={ !! this.state.parsingNvd }
														color={"primary"}
														onClick={ this.addNvdFile }
													>
														<b>
															<TextLabel value={"Add..."} /> <em>nvdcve-*.json</em>
														</b>
														<i>
															<FileIcon />
														</i>
													</Button>
												</ButtonGroup>
											</div>
										</Form>
										{ ( !! this.state.showNvdFilterModal ) && (
											<CveLoaderFilterModal
												close={ ()=>{ this.setState({showNvdFilterModal: false}) } }
												info={ this.state.nvdInfo }
												filter={ this.nvdFilter }
											/>
										)}
									</>
								) }
							</TabPane>
						)}
						{ this.state.tab === "cve" && (
							<TabPane className={"active"}>
								{ ((this.state.files.length + this.state.loadedFolders.length + this.state.loadedHistory.length) === 0) && (
									<div className={"download-links"}>
										<div>
											<Label><strong>cve.org</strong></Label>
										</div>
										<div>
											<a
												href={"https://www.cve.org/Downloads"}
												target="_blank"
												rel="noopener noreferrer"
												title={'🌐 '+Glob.label('Link to an external site')}
											>
												🌐 <TextLabel value={"Download page"} />
											</a>
											<a
												href={"https://codeload.github.com/CVEProject/cvelistV5/zip/refs/heads/main"}
												target="_blank"
												rel="noopener noreferrer"
												title={'⚠️ '+Glob.label('Huge file size')}
											>
												⚠️ <TextLabel value={"Download comprehensive archive"} />
											</a>
										</div>
									</div>
								)}
								{ (this.state.loadedHistory.length > 0) && (
									<div className={"loadedHistory"}>
										{ this.state.loadedHistory.map( (h,idx) => (
											<div key={idx}>
												{h.map(f => (
													<div key={f}>
														<AppOkIcon /> <span>{ f }</span>
													</div>
												))}
											</div>
										))}
									</div>
								) }
								<Form onSubmit={ e => { e.preventDefault(); }}>
									<h6 lang={"it"}>
										Scegli una cartella contenente uno o più file di singole CVE, da CVE.org o da nvd.nist.gov
									</h6>
									<h6 lang={"en"}>
										Choose a folder with one or more individual CVE files, from CVE.org or nvd.nist.gov
									</h6>
									<FolderUploader
										title={ (this.state.lang==='it'?'Cartella di CVE':'CVEs folder')+': cve-*.json' }
										single={true}
										accept={ x=>{
											return !! (x?.name||'').match(/.*CVE.*\.json$/i);
										}}
										onChange={ this.parseFiles }
									/>
								</Form>
							</TabPane>
						)}
					</TabContent>
					<CveLoadStatus />
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"warning"}
							hidden={ ! this.state.nvdInfo }
							onClick={ ()=>{ this.setState({files: [], totalSize: 0, nvdInfo:null })} }
						>
							<i>
								<CloseIcon />
							</i>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
						</Button>
						<Button
							color={"success"}
							disabled={ ! this.state.files.length }
							onClick={ this.loader }
						>
							<b>
								<TextLabel value={"Upload"}/>
							</b>
							<i>
								<AppOkIcon/>
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		);
	}
	render() {
		return (
			<SliderPanel
				title={ <TextLabel value={"CveLoader"} />}
				icon={<AppUploadIcon />}
				className={prefix+' MultiLoader'}
			>
				{ this.state.loading ? this.renderLoader() : this.renderForm() }
			</SliderPanel>
		)
	}
}

export default CveLoader;
